import React from "react";
import { useEffect } from "react";
import basket from "../assests/images/basket.png";
import useShopStore from "../store/useShopStore";
import useUserStore from "../store/useUserStore";
import classes from "./CartBox.module.css";
export default function CartBox(props) {
  const { cart, showCart } = useShopStore((state) => state);
  const { user } = useUserStore((state) => state);

  useEffect(() => {
    showCart();
  }, [cart, user]);
  return (
    <div
      style={{ cursor: "pointer" }}
      onClick={props.onClick}
      className={classes.cartBox}
    >
      <img className={classes.basket} alt="Basket" src={basket} />
      {cart?.products.length > 0 && (
        <span className={classes.qty}>{cart?.products.length}</span>
      )}
    </div>
  );
}
